import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { Eyebrow } from './Eyebrow';
import { processSteps } from '../data/content';
import { contact, urls } from '../data/site';
export function ProcessSection() {
  return <section id="process" aria-labelledby="process-heading" className="bg-paper py-14 md:py-28" data-id="element-107" data-mp="p32pz1i2e7yx">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12" data-id="element-108" data-mp="1mql64xe22ccy">
        <Eyebrow data-id="element-109" data-mp="1msnxbkqy2bj9">Start with a clear next step</Eyebrow>
        <h2 id="process-heading" className="mt-5 max-w-[16ch] font-display text-[40px] font-bold uppercase leading-[0.95] text-ink md:text-[56px] lg:text-[64px]" data-id="element-110" data-mp="1hr8c9soro50v">
          From damage photos to a repair plan.
        </h2>

        <ol className="mt-10 grid border-t-2 border-ink md:mt-16 md:grid-cols-3" data-id="element-111" data-mp="17zuhtzbo9vel">
          {processSteps.map(step => <li key={step.number} className="relative border-b border-line py-6 md:border-b-0 md:border-l md:px-8 md:py-10 md:first:border-l-0 md:first:pl-0" data-id="element-112" data-mp="20qm9cjhslvvl">
              <span aria-hidden="true" className="absolute -top-[2px] left-0 h-[4px] w-12 bg-brand" data-id="element-113" data-mp="2b17lp2vj2ycs" />
              <span className="block font-display text-[48px] font-bold leading-none text-brand md:text-[72px]" data-id="element-114" data-mp="1wd346287osvl">
                {step.number}
              </span>
              <h3 className="mt-5 font-display text-[28px] font-bold uppercase leading-none text-ink md:text-[30px]" data-id="element-115" data-mp="219l48oslk31l">
                {step.title}
              </h3>
              <p className="mt-3 max-w-[22rem] text-[16px] leading-relaxed text-steel md:text-[17px]" data-id="element-116" data-mp="1re9pw7l3oxud">
                {step.description}
              </p>
            </li>)}
        </ol>

        <div className="mt-8 flex flex-col md:mt-12 gap-3 sm:flex-row" data-id="element-117" data-mp="1idlab8g26pfd">
          <ButtonLink href={urls.quote} trailingIcon={ArrowRightIcon} className="w-full sm:w-auto" data-id="element-118" data-mp="37r8c16bjpmw7">
            Request a Repair Quote
          </ButtonLink>
          <ButtonLink href={contact.phoneHref} variant="outlineLight" leadingIcon={PhoneIcon} className="w-full sm:w-auto" data-id="element-119" data-mp="3coqk6uhqny35">
            Call {contact.phoneDisplay}
          </ButtonLink>
        </div>
      </div>
    </section>;
}